<template>
  <div>
    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <slot name="header">
              <CIcon name="cil-grid" />
              {{ title }}
            </slot>
          </CCardHeader>

          <CCardBody>
            <template v-if="!isLoading">
              <TableButton
                :listBoxSource="listBoxSource"
                :visibilityShow="visibilityShow"
                :title="title"
                @addForm="addForm"
                @showHide="showHide"
                @exportXls="exportXls"
                @myListBoxOnCheckChange="myListBoxOnCheckChange($event)"
              ></TableButton>
              <CRow>
                <CCol sm="12">
                  <CButton
                    size="sm"
                    color="primary"
                    name="linkedin"
                    @click="fixOrderForApps()"
                  >
                    <!-- <i class="fa fa-plus-square"></i>&nbsp; -->
                    <span>Re Fixing Order</span>
                  </CButton>
                 
                </CCol>
              </CRow>
              <br />
              <CRow>
                <CCol sm="12">
                  <JqxGrid
                    v-if="items"
                    ref="myGrid"
                    :width="'100%'"
                    :source="items"
                    :columns="fields"
                    :columngroups="fieldsgroup"
                    :columnsresize="true"
                    :sortable="true"
                    :pageable="true"
                    :autoheight="true"
                    :showfilterrow="true"
                    :filterable="true"
                    :enablebrowserselection="false"
                    :enablehover="true"
                    :editable="false"
                    :altrows="true"
                    :localization="localization"
                    :selectionmode="'multiplerowsadvanced'"
                  >
                  </JqxGrid>
                  
                </CCol>
              </CRow>
            </template>
            <Loading v-else></Loading>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{ title }}</h6>
      </template>
      <Loading v-if="isLoading"></Loading>

      <div v-else>
        <CForm>
          <CRow>
            <CCol sm="12">
              <CRow>
                <CCol sm="3">
                  <CInput
                    label="Title"
                    invalid-feedback="Title should be filled"
                    required
                    v-model="$v.promotionForm.title.$model"
                    :is-valid="!$v.promotionForm.title.$invalid"
                  />
                </CCol>
               
              </CRow>
              <CRow>
                <CCol sm="12">
                  <CRow>
                    <CCol sm="9">
                      <label for="nik">Description</label>
                      <quill-editor
                        style="height: 200px; margin-bottom: 70px"
                        :content="content"
                        :options="editorOption"
                        v-model="$v.promotionForm.description.$model"
                        @change="onEditorChange($event)"
                      >
                      </quill-editor>
                      <div
                        v-if="$v.promotionForm.description.$invalid"
                        class="invalid-feedback-custom"
                      >
                        Description harus di isi.
                      </div>
                    </CCol>
                  </CRow>
                </CCol>
              </CRow>
            </CCol>
          </CRow>
        </CForm>
      </div>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton
          @click="submitForm"
          :disabled="$v.promotionForm.$invalid"
          color="success"
        >
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="orderingApps"
    >
      <template #header>
        <h6 class="modal-title">Fix ordering for apps</h6>
      </template>
      <Loading v-if="isLoading"></Loading>

      <div v-else>
        <CForm>
          <CRow>
            <CCol lg="12">
               <draggable
                class="list-group"
                tag="ul"
                v-model="listPromotionApps"
                v-bind="dragOptions"
                @start="isDragging = true"
                @end="isDragging = false"
              >
                <transition-group type="transition" name="flip-list">
                  <li
                    class="list-group-item"
                    v-for="element in listPromotionApps"
                    :key="uniqueId(element.order)"
                  >
                    <i :class="'fa fa-align-justify'"
                      aria-hidden="true"
                    ></i>
                    {{ element.name }}
                  </li>
                </transition-group>
              </draggable>
            
            </CCol>
          </CRow>
        </CForm>
      </div>

      <template #footer>
        <CButton @click="cancelFix" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton
          @click="saveNewOrder"
          color="success"
        >
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
// import GlobalTable from "../../templates/Table";
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required } from "vuelidate/lib/validators";
import Loading from "@/templates/Loading.vue";
import TableButton from "@/templates/TableButton";
import JqxGrid from "jqwidgets-scripts/jqwidgets-vue/vue_jqxgrid.vue";
import draggable from "vuedraggable";
import _ from "lodash";


import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import Quill from "quill";

export default {
  name: "News",
  components: { Loading, quillEditor, JqxGrid, TableButton, draggable },
  data(){
    return {
      title: "News",
      source: {
        localdata: [],
        datafields: [
          { name: "id", type: "number" },
          { name: "title", type: "string" },
          { name: "ordering", type: "string" },
        ],
        datatype: "json",
      },
      editrow: -1,
      listPromotionApps: [],
       dragging: false,
      fields: [
        {
          datafield: "title",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Judul"
        },
        {
          datafield: "ordering",
          columntype: "number",
          filtertype: "textbox",
          text: "Urutan",
          cellsalign: "center",
          align: "center",
          width: 60,
        },
        {
          text: "Edit",
          align: "center",
          name: "EditAction",
          columngroup: "ActionsGroup",
          columntype: "button",
          width: 60,
          sortable: false,
          filtertype: "none",
          menu: false,
          cellsrenderer: () => {
            return "Edit";
          },
          buttonclick: (row) => {
            let dataRecord = this.$refs.myGrid.getrowdata(row);
            let path = this.$route.path.split("/");

            this.$router.push({
              path: path.hasOwnProperty("2")
                ? path[2] + "/detail/" + dataRecord.id
                : "detail/" + dataRecord.id,
            });
          },
        },
         {
          text: "Remove",
          columngroup: "ActionsGroup",
          align: "center",
          name: "CopyAction",
          columntype: "button",
          width: 60,
          sortable: false,
          filtertype: "none",
          menu: false,
          cellsrenderer: () => {
            return "Remove";
          },
          buttonclick: (row) => {
            let dataRecord = this.$refs.myGrid.getrowdata(row);
            // console.log(dataRecord);
            this.removeData(dataRecord);
            //this.cloneProduct(dataRecord);
          },
        },
      ],
      fieldsgroup: [
        {
          text: "Actions",
          align: "center",
          name: "ActionsGroup",
        },
      ],
      listBoxSource: [
        {
          label: "Redirect",
          value: "flag_label",
          checked: true,
        },
        {
          label: "Urutan",
          value: "ordering",
          checked: true,
        },
      ],

      promotionForm: tableInterfaces.promotion,
      items: null,
      statusList: [
        { value: "1", text: "Active" },
        { value: "2", text: "Disabled" },
      ],
      redirectList: [
        { value: "1", text: "Yes" },
        { value: "0", text: "No" },
      ],
      isLoading: false,
      isEdit: false,
      addButton: false,
      orderingApps: false,
      orderingWeb: false,
      content: "",
      editorOption: {}, // data quill
      localization: getLocalization("en"),
      visibilityShow: false,
    };
  },
  validations: {
    promotionForm: {
      title: { required },
      description: {required}
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  methods: {
    //NewTable Function --start
    uniqueId: function (param = "") {
      return _.uniqueId(param);
    },
    onUpdate: function (event) {
      this.listPromotionApps.splice(
        event.newIndex,
        0,
        this.listPromotionApps.splice(event.oldIndex, 1)[0]
      );
    },
    exportXls: function () {
      this.$refs.myGrid.exportdata("xls", "order");
    },
    exportPdf: function () {
      this.$refs.myGrid.exportdata("pdf", "order");
    },
    fixOrderForApps: function () {
      this.orderingApps = true;
      this.orderingWeb = false;
      this.isLoading = true;
      this.listPromotionApps = [];
      this.axios
        .get("console/news/listing-apps")
        .then((response) => {
          if (response.data.status === 2000) {
            this.listPromotionApps = response.data.data;

            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    saveNewOrder: function(event) {
      event.preventDefault();
      if (confirm("Do you want to save new order ?")) {
        this.axios
          .put("console/news/fix-order", {'new_order':this.listPromotionApps})
          .then((response) => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: this.title,
                message: response.data.message,
              });

            } else {
              this.showErrorNotification({
                title: this.title,
                message: response.data.message,
              });
            }
          })
          .catch((error) => {
            this.showErrorNotification({
              title: this.title,
              message: error,
            });
          })
          .finally(() => {
            this.orderingApps = false;
            this.isLoading = false;
            this.init();
          });
      }
    },
    myListBoxOnCheckChange: function (event) {
      this.$refs.myGrid.beginupdate();
      if (event.args.checked) {
        this.$refs.myGrid.showcolumn(event.args.value);
      } else {
        this.$refs.myGrid.hidecolumn(event.args.value);
      }
      this.$refs.myGrid.endupdate();
    },
    showHide: function () {
      this.visibilityShow = !this.visibilityShow;
    },
    // NewTable Function --end
    init: function () {
      this.isEdit = false;
      this.cancelForm();
      this.getNewsList();
    },
    getNewsList: function () {
      this.isLoading = true;
      this.axios
        .get("console/news/listing")
        .then((response) => {
          if (response.data.status === 2000) {
            //this.items = response.data.data;
            const temp = this.source;
            temp.localdata = response.data.data;
            this.items = new jqx.dataAdapter(temp);

            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    addForm: function () {
      this.addButton = true;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    cancelFix: function () {
      this.orderingApps = false;
      this.orderingWeb = false;
    },
    editForm: function (item) {
      this.addForm();
      this.isEdit = true;
      this.promotionForm = item;
    },
    resetForm: function () {
      for (var i in tableInterfaces.promotion) {
        tableInterfaces.promotion[i] = null;
      }
      this.promotionForm = tableInterfaces.promotion;
    },
    removeData: function (item) {
      if (confirm("Are you sure want to remove this news ?")) {
        this.isLoading = true;
        this.axios
          .delete("console/news/remove/"+item.id)
          .then((response) => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: this.title,
                message: response.data.message,
              });
            } else {
              this.showErrorNotification({
                title: this.title,
                message: response.data.message,
              });
            }
          })
          .catch((error) => {
            this.showErrorNotification({
              title: this.title,
              message: error,
            });
          })
          .finally(() => {
            this.isLoading = false;
            this.init();
          });
      }
    },
    submitForm: function (event) {
      event.preventDefault();
      if (confirm("Are you sure want to add this news ?")) {
        let path = this.$route.path.split("/");
        this.isLoading = true;
        this.axios
          .post("console/news/add", this.promotionForm)
          .then((response) => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: this.title,
                message: response.data.message,
              });
              this.$router.push({
                path: path[2] + "/detail/" + response.data.id,
              });
            } else {
              this.showErrorNotification({
                title: this.title,
                message: response.data.message,
              });
            }
          })
          .catch((error) => {
            this.showErrorNotification({
              title: this.title,
              message: error,
            });
          })
          .finally(() => {
            this.isLoading = false;
            this.init();
          });
      }
    },
    onEditorChange({ quill, html, text }) {
      this.content = html;
      this.promotionForm.description = html;
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}

.button {
  margin-top: 35px;
}

.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.list-group {
  min-height: 20px;
}

.list-group-item {
  cursor: move;
}

.list-group-item i {
  cursor: pointer;
}
</style>
